app.controller('recentSalesController', function ($scope, $sce, $filter, $http, $routeParams, $location, storageService, constants, urls, keys, safeApply, cookieService, apiService) {

  mapboxgl.accessToken = apiService.getMapboxAccessToken()

  $scope.cog_loader_title = "Scanning for recent sales..."
  var intro_info_modal = new bootstrap.Modal(document.getElementById('introInfoModal'))

  let bounds,
    subjMap,
    tnsSlider = []

  $scope.analysis = null
  $scope.initializing = true
  $scope.options = {
    map_side: 1,
    small_view: 0,
    page: 'recent_sales',
    notice: { show: true, position: 1 }
  }
  $scope.current_feature = null

  let notice = `<h3>Notice</h3>
                  The deadline to file for Dallas County is May 16th, 2022.`

  initController()
  async function initController() {

    //   $(".preloader").fadeOut(0, 'swing')
    intro_info_modal.show()
    // return

    let county_list = await apiService.countyList()
    county_list = county_list.data.data.data
    console.log('********county_list :>> ', county_list);

    let analysis = await apiService.getAnalysis({ appeal_id: $routeParams.appeal_id, cad_code: $routeParams.cad_code })
    const county = county_list.find(item => item.cad_code == analysis.data.data.analysis.subj.cad_code)
    notice = `<h3>Notice</h3>
              The deadline to file for ${county.county} County is:<br>
              ${$filter('date')(county.protest_window_close, "fullDate")} by midnight.
              <br><br>
              The deadline to sign up for us to file for you is:<br>
              ${$filter('date')(county.gold_signup_cutoff, "EEEE, MMMM d, y h:mma")}.`
    $scope.analysis = analysis.data.data.analysis

    // Insert Notice if active
    if ($scope.options.notice.show && $scope.options.notice.position > 0) {
      $scope.analysis.recentSales.comps.splice($scope.options.notice.position, 0, notice)
    }

    $scope.analysis.stats = { comps: 0, helps: 0, hurts: 0, neutral: 0 }
    const stats = $scope.analysis.recentSales.comps.map(item => {
      $scope.analysis.stats.comps++
      if (item.hasOwnProperty('adjusted_close_price')) {
        if (item.supports_reduction && item.credible == 1) {
          item.status = 'helps'
          $scope.analysis.stats.helps++
        } else if (!item.supports_reduction && item.credible == 1) {
          item.status = 'hurts'
          $scope.analysis.stats.hurts++
        } else {
          item.status = 'neutral'
          $scope.analysis.stats.neutral++
        }

        // Add popovers
        item.popup_info = `<div>
                            <div class="situs" style="text-align: center; font-size: 11px;margin-top: 0px; font-weight: 600;">
                              ${item.situs}
                            </div>
                            <div class="row" style="margin-top: 10px;">
                              <div class="col stats" style="margin-top: 1px;">
                                <table class="table table-sm table-striped" style=" line-height: 1.2; vertical-align: middle;">
                                  <tbody>
                                    <tr>
                                      <td class="text-start">Close Date</td>
                                      <td class="text-end">${item.formated_close_date}</td>
                                    </tr>
                                    <tr>
                                      <td class="text-start">Close Price</td>
                                      <td class="text-end">${item.formated_close_price}</td>
                                    </tr>
                                    <tr>
                                      <td class="text-start">Living Sq/Ft</td>
                                      <td class="text-end">${item.formated_living_sqft}</td>
                                    </tr>
                                    <tr>
                                      <td class="text-start">Year Built</td>
                                      <td class="text-end">${item.year_built}</td>
                                    </tr>
                                    <tr>
                                      <td class="text-start">Adjusted Sales Price</td>
                                      <td class="text-end">${$filter('currency')(item.adjusted_close_price, '$', 0)}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>  
                            </div>
                            </div> `
      }
    })
    console.log('$scope.analysis :>> ', $scope.analysis);
    $scope.initializing = false
    $(".preloader").fadeOut(200, 'swing')
    // intro_info_modal.show()
    initDynamicContent()
    $scope.setMasterMap()
    $scope.subject_map_url = await apiService.setSubjectMap({ lng: $scope.analysis.subj.geo_location.lng, lat: $scope.analysis.subj.geo_location.lat })
    setTimeout(() => {
      var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
      var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
          html: true,
          sanitize: false,
          trigger: 'hover'
        })
      })
      safeApply($scope)
    }, 0)
    safeApply($scope)
  }

  // reset comps view when resizing if manually set to map
  window.onresize = () => { reDrawMap() }
  function reDrawMap() {
    console.log("redraw map");
    if (subjMap) {
      subjMap.resize()
      subjMap.fitBounds(bounds, { padding: 50 })
    }
    if (window.innerWidth >= 1008 && $scope.options.small_view == 1) $scope.toggleMapView('comps')
    // safeApply($scope)
  }
  $scope.toggleMapView = function (show) {
    let elem = $('#recent_sales_analysis_wrapper .comps_wrapper')
    switch (show) {
      case 'map':
        elem.css('display', 'none')
        $scope.options.small_view = 1
        break
      case 'comps':
        elem.css('display', 'block')
        $scope.options.small_view = 0
        break
    }
    reDrawMap()
  }

  $scope.showFullScreenImage = (image) => {
    console.log('image :>> ', image);
    $scope.full_screen_image = image
    safeApply($scope)
  }

  $scope.showFullScreenImages = (comp, images) => {
    $scope.full_screen_images = images
    $scope.full_screen_images_info = comp
    safeApply($scope)
  }

  $scope.updateOption = function (option) {
    switch (option) {
      case 'map_side':
        const rsa_wrapper = document.getElementById('recent_sales_analysis_wrapper')
        const direction = $scope.options.map_side ? 'row' : 'row-reverse'
        rsa_wrapper.style.flexDirection = direction
        break
    }
  }

  $scope.photo_nav = (direction, index) => {
    tnsSlider[index].goTo(direction)
  }

  $scope.showStatModal = (stat, index) => {
    $scope.stat = {
      title: (stat == 1 ? 'Value Reduction indicator' : 'Credibility Indicator'),
      data: (stat == 1 ? $scope.analysis.recentSales.comps[index].acpPopUp : $scope.analysis.recentSales.comps[index].csPopUp)
    }
    safeApply($scope)
  }

  $scope.setMasterMap = () => {
    subjMap = new mapboxgl.Map({
      container: 'masterMap',
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [$scope.analysis.subj.geo_location.lng, $scope.analysis.subj.geo_location.lat],
      pitch: 60,  // pitch in degrees
      bearing: -60, // bearing in degrees
      zoom: 14,
    })
    let mapBounds = [],
      layerSources = [],
      descHTML = '',
      compGeoJson = {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        }
      }

    mapBounds.push({ longitude: $scope.analysis.subj.geo_location.lng, latitude: $scope.analysis.subj.geo_location.lat })

    $scope.analysis.recentSales.comps.forEach((comp, index) => {
      if ($scope.options.notice.show && index != $scope.options.notice.position) {
        mapBounds.push({ longitude: comp.longitude, latitude: comp.latitude })
        descHTML = `<div class="situs" style = "text-align : center;font-size: 14px;margin-top: 10px;font-weight: 600;"> ${comp.situs}</div>
                    <div class="row" style="margin-top: 15px;">
                      <div class="col img-wrapper" style="max-width : 180px; margin-top: 10px;">
                        <img src="${comp.photos[0]}" style="width: 180px; max-width: 100%; border-radius: 7px;" alt="photo">
                      </div>
                      <div class="col stats" style="margin-top: 1px;">
                        <table class="table table-sm table-striped" style=" line-height: 1.2; vertical-align: middle;">
                          <tbody>
                            <tr>
                              <td class="text-start">Close Date</td>
                              <td class="text-end">${comp.formated_close_date}</td>
                            </tr>
                            <tr>
                              <td class="text-start">Close Price</td>
                              <td class="text-end">${comp.formated_close_price}</td>
                            </tr>
                            <tr>
                              <td class="text-start">Living Sq/Ft</td>
                              <td class="text-end">${comp.formated_living_sqft}</td>
                            </tr>
                            <tr>
                              <td class="text-start">Year Built</td>
                              <td class="text-end">${comp.year_built}</td>
                            </tr>
                            <tr>
                              <td class="text-start">Adjusted Sales Price</td>
                              <td class="text-end">${$filter('currency')(comp.adjusted_close_price, '$', 0)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>  
                    </div>
                    <div class="acp-desc" style="text-align: center; border-top: 1px solid lightgray;margin-top: 10px; padding: 8px 0 0 0;">${comp.acpDesc}</div>
                    <div class="cs-desc" style="text-align: center;">${comp.csDesc}</div>
    `

        let reduction_type
        if (comp.supports_reduction && comp.credible == 1) {
          reduction_type = 1
        } else if (!comp.supports_reduction && comp.credible == 1) {
          reduction_type = 2
        } else {
          reduction_type = 3
        }

        compGeoJson.data.features.push({
          type: 'Feature',
          properties: {
            supports_reduction: reduction_type,  //`${ comp.supports_reduction } `,
            title: comp.row_num,
            description: descHTML,
            comp_index: (comp.row_num - 1)
          },
          geometry: {
            type: 'Point',
            coordinates: [comp.longitude, comp.latitude]
          }
        })
      }
    })

    subjMap.on('load', () => {
      bounds = new mapboxgl.LngLatBounds()
      mapBounds.map(prop => {
        bounds.extend([prop.longitude, prop.latitude])
      })

      subjMap.addLayer({
        id: `comp - circles`,
        type: 'circle',
        source: compGeoJson,
        paint: {
          'circle-radius': 12,
          'circle-opacity': 0.8,
          'circle-color': [
            'match',
            ['get', 'supports_reduction'],
            1,
            '#00C09A',
            2,
            '#f9392f',
            3,
            '#a6ced6',
            /* other */ '#ccc'
          ]
        }
      });

      subjMap.addLayer({
        id: 'compLabels',
        type: 'symbol',
        source: compGeoJson,
        layout: {
          'symbol-placement': 'point',
          'text-font': ["Open Sans Bold"],
          'text-field': '{title}',
          'text-size': 14,
        },
        paint: {
          'text-color': [
            'match',
            ['get', 'supports_reduction'],
            1,
            'white',
            2,
            'white',
            3,
            'gray',
            /* other */ '#ccc'
          ]
        }
      })

      new mapboxgl.Marker()
        .setLngLat([$scope.analysis.subj.geo_location.lng, $scope.analysis.subj.geo_location.lat])
        .addTo(subjMap)
      subjMap.fitBounds(bounds, { padding: 50 })

      const popup = new mapboxgl.Popup({ closeButton: false, closeOnClick: false })

      subjMap.on('click', 'compLabels', (e) => {
        const w = window.innerWidth
        if (w > 540) return
        var compInfoModal = new bootstrap.Modal(document.getElementById('compInfoModal'))
        compInfoModal.show()
      })

      subjMap.on('mouseenter', 'compLabels', (e) => {
        const w = window.innerWidth
        console.log('e :>> ', e)
        // let comp_index = e.features[0].properties.comp_index
        // $(".comps_container").animate(
        //   { scrollTop: $(`#prop_card_${ comp_index } `).offset().top },
        //   800
        // )
        if (w > 540) {
          $scope.current_feature = null
          subjMap.getCanvas().style.cursor = 'pointer'
          const coordinates = e.features[0].geometry.coordinates.slice()
          const description = e.features[0].properties.description
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
          }
          popup.setLngLat(coordinates).setHTML(description).addTo(subjMap)
        } else {
          $scope.current_feature = e.features[0]
          safeApply($scope)
          console.log('$scope.current_feature :>> ', $scope.current_feature);
        }
      })
      subjMap.on('mouseleave', 'compLabels', (e) => {
        subjMap.getCanvas().style.cursor = ''
        popup.remove();
      })
    })
  }

  function initDynamicContent() {
    setTimeout(() => {

      SimpleSwitch.init()

      const charts_ri = document.querySelectorAll('.chart_ri')
      const charts_cred = document.querySelectorAll('.chart_cred')
      charts_ri.forEach(chart => {
        const chart_ri = new JustGage({
          id: chart.id,
          min: 0,
          max: 100,
          title: '',
          label: '',
          width: 110,
          height: 90,
          hideValue: true,
          hideMinMax: true,
          pointer: true,
          pointerOptions: {
            toplength: -9,
            bottomlength: 6,
            bottomwidth: 6,
            color: '#2ECC71',
            stroke: '#ffffff',
            stroke_width: 3,
            stroke_linecap: 'round'
          },
          levelColors: ['#D5F5E3', '#ABEBC6', '#82E0AA', '#58D68D', '#2ECC71',],
          gaugeColor: '#E8F8F5',
        })
      })
      charts_cred.forEach(chart2 => {
        const chart_cred = new JustGage({
          id: chart2.id,
          min: 0,
          max: 100,
          title: '',
          label: '',
          width: 110,
          height: 90,
          hideValue: true,
          hideMinMax: true,
          pointer: true,
          pointerOptions: {
            toplength: -9,
            bottomlength: 6,
            bottomwidth: 6,
            color: '#3498DB',
            stroke: '#ffffff',
            stroke_width: 3,
            stroke_linecap: 'round'
          },
          levelColors: ['#D6EAF8', "#AED6F1", "#85C1E9", "#5DADE2", "#3498DB"],
          gaugeColor: '#EBF5FB'
        })
      })

      tippy('.stat_tooltip', {
        allowHTML: true,
        placement: 'top',
        animation: 'scale',
        delay: [600, 0],
      })
      tippy('.data__prices', {
        allowHTML: true,
        placement: 'top',
        animation: 'scale',
        delay: [200, 50],
      })
      tippy('.star', {
        allowHTML: true,
        placement: 'bottom-end',
        animation: 'scale',
        delay: [200, 50],
      })

      const tnsCarousel = document.querySelectorAll('.photo_slider')
      tnsCarousel.forEach((slider, index) => {
        tnsSlider[index] = tns({
          container: slider,
          mode: 'carousel',
          items: 1,
          center: true,
          controls: false,
          nav: false,
          autoWidth: false,
          mouseDrag: true,
          lazyload: true
        })
      })
      $(".preloader").fadeOut(200, 'swing')
    }, 0)



  }

})
// End:  recentSalesController
